import { useCallback } from 'react';
import { CreatePurchaseOrderArgs, useCreatePurchaseOrderBundle } from '../api/hooks/bundles';
import { usePurchaseOrder } from './usePurchaseOrders';

export const useDuplicatePurchaseOrder = (mspId: string, customerId: string, existingOrderId: string) => {
  const orderToDuplicate = usePurchaseOrder(existingOrderId);

  if (!orderToDuplicate) {
    throw Error("Attempting to duplicate an order which doesn't exist");
  }

  const createOrder = useCreatePurchaseOrderBundle();

  return useCallback(
    async (newName: string) => {
      const payload = {
        ...orderToDuplicate,
        addressId: orderToDuplicate.address?.id,
        name: newName,
        customerId,
        mspId
      } as any; 
      // Casting to any because we need to go from a type where code is mandatory
      // to one where it doesn't exist and delete it.

      // Need to remove the code from the payload because codes are supposed to be unique.
      delete payload.code;

      return await createOrder.mutateAsync(payload);
    },
    [orderToDuplicate]
  );
};
